export default __webpack_public_path__ + "static/media/eliqx-banner-hp-web-10-2021.0d2b9d60.jpg";